<template>
    <dash
        icon="fa fa-truck"
        titulo="SERVIÇOS (CONTRATOS)"
        subTitulo="GESCON"
        @click.native="
            $router.push({ name: 'GesconAprovadoresComprometimentos' })
        "
        :qtd="qtd"
        :mostrarQtd="true"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
